import React, { useState, useEffect, useRef } from "react";
import "../../../css/EmployeeOnboardingForm.css";

import Details from "../components/Details";
import PreviousOrganisationDetails from "../components/PreviousOrganisationDetails";
import QualificationFamilyDetails from "../components/QualificationFamilyDetails";
import OtherDetails from "../components/OtherDetails";
import {
  validateOtherDetails,
  validateQualificationDetails,
  validatePersonalDetails,
  validateAddress,
  validatePreviousOrganisationDetails,
  validateAttestationDetails,
  validateReferences,
} from "../utils/employeeOnboardingValidation";
import { getExperienceRowState } from "../utils/experienceRowState";
import Header from "../../../app/layouts/Header";
import Footer from "../../../app/layouts/Footer";
import { Accordion, Navbar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faAngleLeft,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import {
  mapPreOnboardingPayload,
  mapPreviousOrganisationPayload,
} from "../../jobs/mappers/preOnboardingPayloadMapper";

import {
  mapCandidateDetails,
  mapPreviousEmploymentDetails,
  mapQualificationDetails,
  mapOtherDetails,
} from "../../jobs/mappers/onboardingMapper";

import jobsApiService from "../services/jobsApiService";
import masterApi from "../../../services/master.api";

import { useLocation, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

const EmployeeOnboardingForm = () => {
  const contentRef = useRef(null);

  const location = useLocation();
  const navigate = useNavigate();
  const positionId = location.state?.positionId;
  const applicationId = location.state?.applicationId;
  const stepperId = location.state?.stepperId ?? 1;

  const [activeStep, setActiveStep] = useState(
    Math.max(0, (stepperId || 1) - 1),
  );
  const [masterData, setMasterData] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [showBackModal, setShowBackModal] = useState(false);

  const [formData, setFormData] = useState({
    employeeNo: "",
    position: "",
    employmentStatus: "",
    fullNameSSC: "",
    gender: "",
    dob: "",
    maritalStatus: "",

    mobile: "",
    email: "",

    stateOfOrigin: "",
    stateOfDomicile: "",
    nationality: "",
    bloodGroup: "",

    cibilScore: "",
    cibilScoreDate: "",

    personWithDisability: "",
    disabilityPercentage: "",
    natureOfDisability: "",
    disabilityBoardName: "",
    disabilityReferenceNumber: "",
    disabilityCertificateDate: "",
    disabilityFile: null,

    // Previous Organisation Details
    panCardNumber: "",
    empCode: "",
    organisationName: "",
    organisationAddress: "",
    designation: "",
    descriptionOfWork: "",
    lastDrawnSalary: "",
    fromDate: "",
    toDate: "",
    reasonForLeaving: "",
    employerEmail: "",
    employerContact: "",
    voterIdDocumentId: null,
    passportDocumentId: null,
    drivingLicenceDocumentId: null,
    preOnboardingId: "",

    // Attestation Details
    attestationFromDate: "",
    attestationToDate: "",
    addressLine1: "",
    addressLine2: "",
    addressLine3: "",
    city: "",
    state: "",
    district: "",
    pinCode: "",
    attestationDocument: null,

    permanentAddressLine1: "",
    permanentAddressLine2: "",
    permanentAddressLine3: "",
    permanentCity: "",
    permanentState: "",
    permanentDistrict: "",
    permanentPinCode: "",

    markOfIdentification: "",
    practicalTraining: "",
    publications: "",
    futureCourse: "",
    professionalMembership: "",
    legalHistory: "",
    otherInformation: "",

    referenceDetails: "",
    referenceName: "",
    referenceDesignation: "",
    referenceOrganisation: "",
    referenceContact: "",
    referenceEmail: "",

    passportPhoto: null,
    otherDocuments: null,
    selectedDocument: "",
    addressProofFile: null,

    experienceDetails: [],
    attestationDetails: [],
    qualificationDetails: [],
    certificationDetails: [
      {
        certificationId: null,
        certificationName: "",
        institutionName: "",
        certificationDateOfPassing: "",
        certificationPercentage: "",
        fileUrl: "",
        displayName: "",
        uploadDocument: null,
      },
    ],
    // certificationDetails: [],
    preOnboardingFamilyDetails: [
      {
        familyId: "",
        familyPreOnboardingId: "",
        fullName: "",
        relationship: "",
        dateOfBirth: "",
        nationality: "",
        dependent: "",
        benchmarkDisability: "",
        occupation: "",
        annualIncome: "",
        mobileNumber: "",
      },
    ],
    panCanDelete: false,
    drivingLicenceCanDelete: false,
    passportCanDelete: false,
    voterIdCanDelete: false,

    preOnboardingGratuityNomination: [
      {
        gratuityId: "",
        gratuityPreOnboardingId: "",
        nomineeName: "",
        nomineeRelationship: "",
        nomineeAge: "",
        nomineeAddress: "",
        amountOfShare: "",
      },
    ],

    preOnboardingReferences: [
      {
        id: "",
        preOnboardingId: "",
        referenceName: "",
        referenceDesignation: "",
        referenceOrganisation: "",
        referenceContact: "",
        referenceEmail: "",

        referenceDocumentId: "",
        referenceDocumentUrl: "",
        referenceDocumentName: "",
        referenceDocument: null,
        isNew: false,
      },
      {
        id: "",
        preOnboardingId: "",
        referenceName: "",
        referenceDesignation: "",
        referenceOrganisation: "",
        referenceContact: "",
        referenceEmail: "",

        referenceDocumentId: "",
        referenceDocumentUrl: "",
        referenceDocumentName: "",
        referenceDocument: null,
        isNew: false,
      },
    ],

    preOnboardingOtherDetails: {
      id: "",
      preOnboardingId: "",
      identificationMark: "",
      practicalTrainingDetails: "",
      publicationDetails: "",
      pursuingFurtherCourse: false,
      furtherCourseDetails: "",
      memberOfProfessionalBody: false,
      professionalBodyDetails: "",
      memberOfPoliticalBody: false,
      politicalBodyDetails: "",
      criminalCaseDeclared: false,
      criminalCaseDetails: "",
      additionalInformation: "",
    },
  });

  const handleAddExperience = () => {
    setFormData((prev) => {
      return {
        ...prev,
        experienceDetails: [
          ...prev.experienceDetails,
          {
            id: null,
            workExperienceId: "",
            preOnboardingId: prev.preOnboardingId, // <-- add this

            pranCardNumber: prev.experienceDetails[0]?.pranCardNumber || "",
            empCode: "",
            organisationName: "",
            organisationAddress: "",
            designation: "",
            descriptionOfWork: "",
            isCurrentlyWorking: false,
            lastDrawnSalary: "",
            fromDate: "",
            toDate: "",
            reasonForLeaving: "",
            employerEmail: "",
            employerContact: "",
            experienceCertificateUrl: "",
            experienceCertificateName: "",
            preOnboardingDocumentId: null,
            isCandidateRemove: true,
            isNew: true,
            isEditable: true,
            isEditedFromYesToNo: false,
          },
        ],
      };
    });
  };

  const handleRemoveExperience = (index) => {
    setFormData((prev) => {
      const updatedExperiences = prev.experienceDetails.filter((_, i) => i !== index);
      const reEnabledIndex = updatedExperiences.findIndex(
        (exp) => exp.isEditedFromYesToNo,
      );

      if (reEnabledIndex !== -1) {
        return {
          ...prev,
          experienceDetails: updatedExperiences.map((exp, i) => ({
            ...exp,
            isEditable: i === reEnabledIndex,
          })),
        };
      }

      return {
        ...prev,
        experienceDetails: updatedExperiences,
      };
    });

    setErrors((prev) => {
      const updatedErrors = { ...prev.experienceDetails };

      delete updatedErrors[index];

      // Re-index remaining errors
      const reIndexedErrors = {};
      Object.keys(updatedErrors).forEach((key) => {
        const currentIndex = Number(key);

        if (currentIndex > index) {
          reIndexedErrors[currentIndex - 1] = updatedErrors[key];
        } else {
          reIndexedErrors[currentIndex] = updatedErrors[key];
        }
      });

      return {
        ...prev,
        experienceDetails: reIndexedErrors,
      };
    });
  };
  const [checklist, setChecklist] = useState({
    workstation: "",
    tools: "",
  });

  useEffect(() => {
    const loadMasterData = async () => {
      try {
        const [masterResponse, documentTypeResponse, certificationResponse] =
          await Promise.all([
            masterApi.getMasterData(),
            masterApi.getDocumentTypes(),
            masterApi.getCertifications(),
          ]);

        setMasterData({
          ...masterResponse.data,
          documentTypes: documentTypeResponse.data,
          certificationMaster: certificationResponse.data.data, // <-- add this
        });
      } catch (error) {
        console.error(error);
      }
    };

    loadMasterData();
  }, []);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [activeStep]);

  useEffect(() => {
    const loadData = async () => {
      if (!applicationId) return;

      // wait until master data loaded
      if (!masterData?.states?.length) return;

      if (activeStep === 0) {
        await fetchPreOnboardingProfile(applicationId);
      }

      if (activeStep === 1) {
        await fetchPreviousEmploymentDetails(applicationId);
      }

      if (activeStep === 2) {
        await fetchQualificationDetails(applicationId);
      }

      if (activeStep === 3) {
        await fetchOthersDetails(applicationId);
      }
    };

    loadData();
  }, [positionId, applicationId, activeStep, masterData]);

  const fetchPreviousEmploymentDetails = async (applicationId) => {
    try {
      const response =
        await jobsApiService.getPreviousEmploymentDetails(applicationId);

      const mappedData = mapPreviousEmploymentDetails(
        response.data,
        masterData,
      );

      const updatedAttestationDetails = mappedData.attestationDetails.map(
        (item) => ({
          ...item,
          state:
            masterData?.states?.find((s) => s.stateId === item.stateId)
              ?.stateName || "",
          district:
            masterData?.districts?.find((d) => d.districtId === item.districtId)
              ?.districtName || "",
          city:
            masterData?.cities?.find((c) => c.cityId === item.cityId)
              ?.cityName || "",
        }),
      );

      setFormData((prev) => ({
        ...prev,
        experienceDetails: mappedData.experienceDetails,
        attestationDetails: updatedAttestationDetails,
      }));

      setAttestationDetails(updatedAttestationDetails);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchQualificationDetails = async (applicationId) => {
    try {
      const response =
        await jobsApiService.getQualificationDetails(applicationId);

      const mappedData = mapQualificationDetails(response.data, masterData);

      console.log("========== MASTER DATA ==========");
      console.log(masterData);

      console.log("Certification Master:", masterData?.certificationMaster);

      console.log(
        "Mapped Candidate Certifications:",
        mappedData.candidateCertifications,
      );

      console.log(
        "Certification Details Before setFormData:",
        mappedData.candidateCertifications,
      );

      console.log(
        "Mapped Certifications",
        JSON.stringify(mappedData.candidateCertifications, null, 2),
      );

      console.log("========== Mapped Certifications ==========");
      console.log(mappedData.candidateCertifications);

      mappedData.candidateCertifications?.forEach((item, index) => {
        console.log(`Certificate ${index}`, {
          certificationMasterId: item.certificationMasterId,
          certificationName: item.certificationName,
          otherCertificationName: item.otherCertificationName,
          candidateCertificateId: item.candidateCertificateId,
          preOnboardingCandDocId: item.preOnboardingCandDocId,
        });
      });

      // Remove empty certificates returned from API
      const validCertificates = (mappedData.candidateCertifications || [])
        .filter(
          (item) =>
            item.certificationName?.trim() ||
            item.certificationMasterId ||
            item.institutionName?.trim() ||
            item.certificationDateOfPassing ||
            item.certificationPercentage ||
            item.fileUrl ||
            item.preOnboardingCandDocId,
        )
        .map((item) => ({
          ...item,
          isAdded: false,
        }));

      setFormData((prev) => ({
        ...prev,

        qualificationDetails: mappedData.qualificationDetails || [],

        certificationDetails:
          validCertificates.length > 0
            ? validCertificates
            : [
              {
                certificationId: null,
                certificationName: "",
                certificationMasterId: "",
                institutionName: "",
                certificationDateOfPassing: "",
                certificationPercentage: "",
                fileUrl: "",
                displayName: "",
                uploadDocument: null,
                preOnboardingCandDocId: null,
                isAdded: false,
              },
            ],

        preOnboardingFamilyDetails:
          mappedData.preOnboardingFamilyDetails?.length > 0
            ? mappedData.preOnboardingFamilyDetails.map((item) => ({
              ...item,
              isAdded: false,
            }))
            : [
              {
                familyId: "",
                familyPreOnboardingId: "",
                fullName: "",
                relationship: "",
                dateOfBirth: "",
                nationality: "",
                dependent: "",
                benchmarkDisability: "",
                occupation: "",
                annualIncome: "",
                mobileNumber: "",
                isAdded: false,
              },
            ],

        preOnboardingGratuityNomination:
          mappedData.preOnboardingGratuityNomination?.length > 0
            ? mappedData.preOnboardingGratuityNomination.map((item) => ({
              ...item,
              isAdded: false,
            }))
            : [
              {
                gratuityId: "",
                gratuityPreOnboardingId: "",
                nomineeName: "",
                nomineeRelationship: "",
                nomineeAge: "",
                nomineeAddress: "",
                amountOfShare: "",
                isAdded: false,
              },
            ],
      }));
    } catch (error) {
      console.error(error);
    }
  };

  // const fetchQualificationDetails = async (applicationId) => {
  //   try {
  //     const response =
  //       await jobsApiService.getQualificationDetails(applicationId);

  //     const mappedData = mapQualificationDetails(response.data, masterData);

  //     setFormData((prev) => ({
  //       ...prev,
  //       qualificationDetails: mappedData.qualificationDetails || [],

  //               certificationDetails:
  //     mappedData.candidateCertifications?.length
  //         ? mappedData.candidateCertifications.map(item => ({
  //               ...item,
  //               isAdded: false,
  //           }))
  //         : [
  //               {
  //                   certificationId: null,
  //                   certificationName: "",
  //                   institutionName: "",
  //                   certificationDateOfPassing: "",
  //                   certificationPercentage: "",
  //                   fileUrl: "",
  //                   displayName: "",
  //                   uploadDocument: null,
  //               },
  //           ],

  //                     // preOnboardingFamilyDetails:
  //                     //     mappedData.preOnboardingFamilyDetails || {},

  // preOnboardingFamilyDetails:
  //     mappedData.preOnboardingFamilyDetails?.length > 0
  //         ? mappedData.preOnboardingFamilyDetails.map(item => ({
  //               ...item,
  //               isAdded: false,
  //           }))
  //         : [
  //               {
  //                   familyId: "",
  //                   familyPreOnboardingId: "",
  //                   fullName: "",
  //                   relationship: "",
  //                   dateOfBirth: "",
  //                   nationality: "",
  //                   dependent: "",
  //                   benchmarkDisability: "",
  //                   occupation: "",
  //                   annualIncome: "",
  //                   mobileNumber: "",
  //                   isAdded: false,
  //               },
  //           ],

  // preOnboardingGratuityNomination:
  //     mappedData.preOnboardingGratuityNomination?.length > 0
  //         ? mappedData.preOnboardingGratuityNomination.map(item => ({
  //               ...item,
  //               isAdded: false,
  //           }))
  //         : [
  //               {
  //                   gratuityId: "",
  //                   gratuityPreOnboardingId: "",
  //                   nomineeName: "",
  //                   nomineeRelationship: "",
  //                   nomineeAge: "",
  //                   nomineeAddress: "",
  //                   amountOfShare: "",
  //                   isAdded: false,
  //               },
  //           ],
  //                 }));
  //           } catch (error) {
  //               console.error(error);
  //           }
  //       };

  const fetchOthersDetails = async (applicationId) => {
    try {
      const response = await jobsApiService.getOthersDetails(applicationId);

      const mappedData = mapOtherDetails(response.data, masterData);
      setFormData((prev) => {
        const references = mappedData.preOnboardingReferences?.length
          ? mappedData.preOnboardingReferences
          : prev.preOnboardingReferences;

        while (references.length < 2) {
          references.push({
            id: "",
            preOnboardingId: "",
            referenceName: "",
            referenceDesignation: "",
            referenceOrganisation: "",
            referenceContact: "",
            referenceEmail: "",
            referenceDocumentId: "",
            referenceDocumentUrl: "",
            referenceDocumentName: "",
            referenceDocument: null,
            isNew: false,
          });
        }

        return {
          ...prev,
          preOnboardingOtherDetails: mappedData.preOnboardingOtherDetails || {},
          preOnboardingReferences: references,
        };
      });
    } catch (error) {
      console.error(error);
    }
  };

  const fetchPreOnboardingProfile = async (applicationId) => {
    try {
      const response =
        await jobsApiService.getPreOnboardingProfileDetails(applicationId);

      const mappedData = mapCandidateDetails(response.data, masterData);

      setFormData((prev) => ({
        ...prev,
        ...mappedData,
          panFromApi: !!mappedData.panNo,
          drivingLicenceFromApi: !!mappedData.drivingLicenceNo,
          passportFromApi: !!mappedData.passportNo
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const [attestationDetails, setAttestationDetails] = useState([
    {
      attestationFromDate: "",
      attestationToDate: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      city: "",
      state: "",
      district: "",
      stateId: "",
      districtId: "",
      cityId: "",
      cityName: "",
      pinCode: "",
      attestationDocument: null,
      preOnboardingDocumentId: null,
    },
  ]);

  const handleFamilyChange = (index, e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = [...prev.preOnboardingFamilyDetails];

      updated[index] = {
        ...updated[index],
        [name]: value,
      };

      return {
        ...prev,
        preOnboardingFamilyDetails: updated,
      };
    });

    setErrors((prev) => {
      const updated = { ...prev };

      if (updated.preOnboardingFamilyDetails?.[index]) {
        delete updated.preOnboardingFamilyDetails[index][name];

        if (
          Object.keys(updated.preOnboardingFamilyDetails[index]).length === 0
        ) {
          delete updated.preOnboardingFamilyDetails[index];
        }
      }

      return updated;
    });
  };

  const addFamily = () => {
    setFormData((prev) => ({
      ...prev,
      preOnboardingFamilyDetails: [
        ...prev.preOnboardingFamilyDetails,
        {
          familyId: "",
          familyPreOnboardingId: "",
          fullName: "",
          relationship: "",
          dateOfBirth: "",
          nationality: "",
          dependent: "",
          benchmarkDisability: "",
          occupation: "",
          annualIncome: "",
          mobileNumber: "",
          isAdded: true,
        },
      ],
    }));
  };

  const removeFamily = (index) => {
    setFormData((prev) => ({
      ...prev,
      preOnboardingFamilyDetails: prev.preOnboardingFamilyDetails.filter(
        (_, i) => i !== index,
      ),
    }));
  };

  const addNominee = () => {
    setFormData((prev) => ({
      ...prev,
      preOnboardingGratuityNomination: [
        ...prev.preOnboardingGratuityNomination,
        {
          gratuityId: "",
          gratuityPreOnboardingId: "",
          nomineeName: "",
          nomineeRelationship: "",
          nomineeAge: "",
          nomineeAddress: "",
          amountOfShare: "",
          isAdded: true,
        },
      ],
    }));
  };

  // const removeNominee = (index) => {
  //     setFormData((prev) => ({
  //         ...prev,
  //         preOnboardingGratuityNomination:
  //             prev.preOnboardingGratuityNomination.filter(
  //                 (_, i) => i !== index
  //             ),
  //     }));
  // };

  const removeNominee = (index) => {
    setFormData((prev) => ({
      ...prev,
      preOnboardingGratuityNomination:
        prev.preOnboardingGratuityNomination.filter((_, i) => i !== index),
    }));
  };

  const handleGratuityChange = (index, e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = [...prev.preOnboardingGratuityNomination];

      updated[index] = {
        ...updated[index],
        [name]: value,
      };

      return {
        ...prev,
        preOnboardingGratuityNomination: updated,
      };
    });

    setErrors((prev) => {
      const updated = { ...prev };

      if (updated.preOnboardingGratuityNomination?.[index]) {
        delete updated.preOnboardingGratuityNomination[index][name];

        if (
          Object.keys(updated.preOnboardingGratuityNomination[index]).length ===
          0
        ) {
          delete updated.preOnboardingGratuityNomination[index];
        }
      }

      return updated;
    });
  };

  const handleOtherDetailsChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      preOnboardingOtherDetails: {
        ...prev.preOnboardingOtherDetails,
        [name]: value,
      },
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));

    setErrors((prev) => {
      const updated = { ...prev };
      delete updated[name];
      return updated;
    });
  };

  const scrollToFirstError = () => {
    setTimeout(() => {
      const firstErrorField = document.querySelector(
        ".is-invalid, .border-danger, .react-select__control--is-invalid",
      );

      if (firstErrorField) {
        firstErrorField.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });

        firstErrorField.focus?.();
      }
    }, 100);
  };

  const handleExperienceChange = (index, field, value) => {
    setFormData((prev) => {
      let updatedExperiences = [...prev.experienceDetails];

      if (field === "pranCardNumber") {
        updatedExperiences = updatedExperiences.map((exp) => ({
          ...exp,
          pranCardNumber: value,
        }));
      } else if (field === "isCurrentlyWorking") {
        const wasCurrentlyWorkingBefore =
          prev.experienceDetails[index]?.isCurrentlyWorking === true;

        updatedExperiences = updatedExperiences.map((exp, i) => {
          const rowState = getExperienceRowState({
            currentExperience: exp,
            index: i,
            selectedIndex: index,
            isCurrentlyWorkingValue: i === index ? value : false,
            wasCurrentlyWorkingBefore,
          });

          return {
            ...exp,
            ...rowState,
          };
        });

        if (value) {
          updatedExperiences[index].toDate = "";
          updatedExperiences[index].reasonForLeaving = "";
        }
      } else {
        updatedExperiences[index] = {
          ...updatedExperiences[index],
          [field]: value,
        };
      }
      return {
        ...prev,
        experienceDetails: updatedExperiences,
      };
    });

    setErrors((prev) => {
      if (field === "pranCardNumber") {
        const updatedErrors = { ...prev.experienceDetails };

        Object.keys(updatedErrors || {}).forEach((key) => {
          updatedErrors[key] = {
            ...updatedErrors[key],
            pranCardNumber: "",
          };
        });

        return {
          ...prev,
          experienceDetails: updatedErrors,
        };
      }

      return {
        ...prev,
        experienceDetails: {
          ...prev.experienceDetails,
          [index]: {
            ...prev.experienceDetails?.[index],
            [field]: "",
          },
        },
      };
    });
  };

  const handleQualificationChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...prev.qualificationDetails];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      return {
        ...prev,
        qualificationDetails: updated,
      };
    });
    setErrors((prev) => ({
      ...prev,
      qualificationDetails: {
        ...prev.qualificationDetails,
        [index]: {
          ...prev.qualificationDetails?.[index],
          [field]: "",
        },
      },
    }));
  };

  const handleReferenceChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...prev.preOnboardingReferences];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      return {
        ...prev,
        preOnboardingReferences: updated,
      };
    });

    setErrors((prev) => {
      const updatedErrors = { ...prev };

      if (updatedErrors[index]) {
        updatedErrors[index] = {
          ...updatedErrors[index],
          [field]: "",
        };

        if (Object.values(updatedErrors[index]).every((v) => !v)) {
          delete updatedErrors[index];
        }
      }

      return updatedErrors;
    });
  };

  const handleCertificationChange = (index, field, value) => {
    setFormData((prev) => {
      const updated = [...prev.certificationDetails];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      return {
        ...prev,
        certificationDetails: updated,
      };
    });

    setErrors((prev) => {
      const newErrors = { ...prev };

      if (newErrors.certificationDetails?.[index]) {
        delete newErrors.certificationDetails[index][field];

        if (Object.keys(newErrors.certificationDetails[index]).length === 0) {
          delete newErrors.certificationDetails[index];
        }
      }

      return newErrors;
    });
  };

  const addCertificate = () => {
    setFormData((prev) => ({
      ...prev,
      certificationDetails: [
        ...prev.certificationDetails,
        {
          certificationId: null,
          certificationName: "",
          institutionName: "",
          certificationDateOfPassing: "",
          certificationPercentage: "",
          fileUrl: "",
          displayName: "",
          uploadDocument: null,
          isAdded: true,
        },
      ],
    }));
  };

  const removeCertificate = (index) => {
    // Remove certificate row
    setFormData((prev) => ({
      ...prev,
      certificationDetails: prev.certificationDetails.filter(
        (_, i) => i !== index,
      ),
    }));

    // Remove and re-index validation errors
    setErrors((prev) => {
      const updatedErrors = { ...(prev.certificationDetails || {}) };

      delete updatedErrors[index];

      const reIndexedErrors = {};

      Object.keys(updatedErrors).forEach((key) => {
        const currentIndex = Number(key);

        if (currentIndex > index) {
          reIndexedErrors[currentIndex - 1] = updatedErrors[key];
        } else {
          reIndexedErrors[currentIndex] = updatedErrors[key];
        }
      });

      return {
        ...prev,
        certificationDetails: reIndexedErrors,
      };
    });
  };

  // const handleQualificationChange = (
  //     index,
  //     field,
  //     value
  // ) => {
  //     setFormData((prev) => {
  //         const updatedQualifications = [
  //             ...(prev.qualificationDetails || []),
  //         ];

  //         updatedQualifications[index] = {
  //             ...updatedQualifications[index],
  //             [field]: value,
  //         };

  //         return {
  //             ...prev,
  //             qualificationDetails:
  //                 updatedQualifications,
  //         };
  //     });

  //     setErrors((prev) => ({
  //         ...prev,
  //         qualificationDetails: {
  //             ...prev.qualificationDetails,
  //             [index]: {
  //                 ...prev.qualificationDetails?.[
  //                 index
  //                 ],
  //                 [field]: "",
  //             },
  //         },
  //     }));
  // };

  // const handleAttestationChange = (
  //     index,
  //     field,
  //     value
  // ) => {
  //     setAttestationDetails(prev => {
  //         const updated = [...prev];

  //         updated[index] = {
  //             ...updated[index],
  //             [field]: value,
  //         };

  //         return updated;
  //     });

  //     setErrors(prev => ({
  //         ...prev,
  //         attestation: {
  //             ...prev.attestation,
  //             [index]: {
  //                 ...prev.attestation?.[index],
  //                 [field]: "",
  //             },
  //         },
  //     }));
  // };

  const handleAttestationChange = (index, field, value) => {
    setAttestationDetails((prev) => {
      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      return updated;
    });

    // Clear field error immediately
    setErrors((prev) => ({
      ...prev,
      attestation: {
        ...prev.attestation,
        [index]: {
          ...prev.attestation?.[index],
          [field]: "",
        },
      },
    }));
  };

  // const handleAttestationChange = (
  //     index,
  //     field,
  //     value
  // ) => {
  //     const updated = [...attestationDetails];

  //     updated[index] = {
  //         ...updated[index],
  //         [field]: value,
  //     };

  //     setAttestationDetails(updated);

  //     // Clear field error immediately
  //     setErrors((prev) => {
  //         const updatedErrors = { ...prev };

  //         if (
  //             updatedErrors.attestation?.[index]?.[field]
  //         ) {
  //             delete updatedErrors.attestation[index][field];

  //             if (
  //                 Object.keys(
  //                     updatedErrors.attestation[index]
  //                 ).length === 0
  //             ) {
  //                 delete updatedErrors.attestation[index];
  //             }
  //         }

  //         return updatedErrors;
  //     });
  // };

  const handleSubmit = () => {
    console.log({
      formData,
      checklist,
    });
  };

  const handleAddressChange = (e) => {
    const { name, type, checked } = e.target;
    let { value } = e.target;

    // Allow only numbers for pincode fields
    if (name === "corrPincode" || name === "permanentPincode") {
      value = value.replace(/\D/g, "").slice(0, 6);
    }

    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        sameAsCorrespondence: checked,

        ...(checked && {
          permAddressLine1: prev.corrAddressLine1,
          permAddressLine2: prev.corrAddressLine2,
          permCity: prev.corrCity,
          permState: prev.corrState,
          permPincode: prev.corrPincode,
        }),
      }));
      return;
    }

    setFormData((prev) => {
      const updated = {
        ...prev,
        [name]: value,
      };

      if (name === "corrCity") {
        updated.corrPincode = "";
      }

      if (name === "permCity") {
        updated.permPincode = "";
        updated.permanentPincode = "";
      }

      if (prev.sameAsCorrespondence) {
        switch (name) {
          case "corrAddressLine1":
            updated.permAddressLine1 = value;
            break;
          case "corrAddressLine2":
            updated.permAddressLine2 = value;
            break;
          case "corrCity":
            updated.permCity = value;
            break;
          case "corrState":
            updated.permState = value;
            break;
          case "corrPincode":
            updated.permPincode = value;
            updated.permanentPincode = value;
            break;
          default:
            break;
        }
      }

      return updated;
    });
  };

  const steps = [
    "Personal Details",
    "Previous Organisation",
    "Qualification & Family Details",
    "Other Details",
  ];

  const [errors, setErrors] = useState({});

  const handleOtherDetailsSubmit = async () => {
    const otherErrors = validateOtherDetails(formData);

    const referenceErrors = validateReferences(formData);

    const validationErrors = {
      ...otherErrors,
      ...referenceErrors,
    };

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      scrollToFirstError();

      toast.error("Please fill all required fields.", {
        position: "top-right",
        autoClose: 3000,
      });

      // toast.error(
      //     "Please fill all required fields."
      // );
      return;
    }

    const saved = await saveOtherDetails();

    if (!saved) return;
    setIsSubmitted(true);
    setShowSuccessModal(true);
    toast.success("Employee onboarding form submitted successfully.");

    handleSubmit();
  };

  const handleQualificationNext = async () => {
    const qualificationErrors = validateQualificationDetails(formData);

    setErrors(qualificationErrors);

    const errorCount = Object.keys(qualificationErrors).length;

    if (errorCount > 0) {
      scrollToFirstError();

      // Don't show toast when only share percentage is invalid
      if (!qualificationErrors.gratuityShareError) {
        toast.error("Please fill all required fields.", {
          position: "top-right",
          autoClose: 3000,
        });
      }

      return;
    }

    const saved = await saveQualificationDetails();

    if (!saved) {
      return;
    }

    toast.success("Step 3 completed and saved successfully.", {
      position: "top-right",
      autoClose: 3000,
    });

    setActiveStep(3);
  };

  const saveQualificationDetails = async () => {
    try {
      const payload = {
        preOnboardingQualifications: formData.qualificationDetails.map(
          (item) => ({
            id: null,
            educationId: item.educationId || null,

            preOnboardingId: item.preOnboardingId || null,

            qualificationName: item.courseId,

            institutionName: item.schoolInstitution,

            specialization: item.specializationId,

            universityName: item.universityName,

            percentage: Number(item.percentageMarks) || 0,

            passingDate: item.dateOfPassing,

            division: item.division,

            courseNature: item.educationTypeId,

            isCurrentlyWorking: false,
          }),
        ),

        preOnboardingCertifications: formData.certificationDetails
          .filter((item) => {
            return (
              item.certificationName?.trim() ||
              item.certificationMasterId ||
              item.otherCertificationName?.trim() ||
              item.institutionName?.trim() ||
              item.certificationDateOfPassing ||
              item.certificationPercentage ||
              item.preOnboardingCandDocId ||
              item.fileUrl
            );
          })
          .map((item) => ({
            id: item.id || null,
            preOnboardingId: item.preOnboardingId || applicationId,

            // Send selected master id
            certificationId: item.certificationMasterId || null,

            // Send custom name when "Other" is selected
            certificationName:
              item.certificationName === "Other"
                ? item.otherCertificationName
                : item.certificationName,

            institutionName: item.institutionName || "",
            passingDate: item.certificationDateOfPassing || null,
            percentage: Number(item.certificationPercentage) || 0,

            candidateCertificateId: item.candidateCertificateId || null,
            preOnboardingCandDocId: item.preOnboardingCandDocId || null,
          })),

        preOnboardingFamilyDetails: formData.preOnboardingFamilyDetails.map(
          (item) => ({
            familyId: item.familyId || null,
            familyPreOnboardingId: item.familyPreOnboardingId || null,

            fullName: item.fullName,
            relationship: item.relationship,
            dateOfBirth: item.dateOfBirth,
            nationality: item.nationality,

            isDependent: item.dependent === "Yes",
            isPwd: item.benchmarkDisability === "Yes",

            occupation: item.occupation,
            annualIncome: Number(item.annualIncome) || 0,
            mobileNumber: item.mobileNumber,
          }),
        ),

        preOnboardingGratuityNomination:
          formData.preOnboardingGratuityNomination.map((item) => ({
            gratuityId: item.gratuityId || null,
            gratuityPreOnboardingId: item.gratuityPreOnboardingId || null,

            nomineeName: item.nomineeName,
            nomineeAddress: item.nomineeAddress,
            nomineeRelationship: item.nomineeRelationship,
            nomineeAge: Number(item.nomineeAge) || 0,
            sharePercentage: Number(item.amountOfShare) || 0,
          })),
      };

      await jobsApiService.saveQualificationDetails(applicationId, payload);

      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  const savePreOnboardingProfile = async () => {
    try {
      const payload = mapPreOnboardingPayload(formData);

      await jobsApiService.saveOrUpdatePreOnboardingProfile(
        applicationId,
        payload,
      );

      return true;
    } catch (error) {
      console.error("Error Saving Pre-Onboarding Profile", error);

      toast.error("Failed to save onboarding details.");

      return false;
    }
  };

  const saveOtherDetails = async () => {
    try {
      const payload = {
        preOnboardingReferences: formData.preOnboardingReferences.map(
          (item) => ({
            id: item.id || null,
            preOnboardingId: item.preOnboardingId || null,

            referenceName: item.referenceName,

            designation: item.referenceDesignation,

            organisation: item.referenceOrganisation,

            contactNumber: item.referenceContact,

            emailId: item.referenceEmail,

            preOnboardingReferenceDocTypeId: item.referenceDocumentId || null,
          }),
        ),

        preOnboardingOtherDetails: {
          id: null,

          preOnboardingId: null,

          identificationMark:
            formData.preOnboardingOtherDetails.markOfIdentification,

          practicalTrainingDetails:
            formData.preOnboardingOtherDetails.practicalTraining,

          publicationDetails: formData.preOnboardingOtherDetails.publications,

          pursuingFurtherCourse:
            !!formData.preOnboardingOtherDetails.futureCourse,

          furtherCourseDetails: formData.preOnboardingOtherDetails.futureCourse,

          memberOfProfessionalBody:
            !!formData.preOnboardingOtherDetails.professionalMembership,

          professionalBodyDetails:
            formData.preOnboardingOtherDetails.professionalMembership,

          memberOfPoliticalBody: false,

          politicalBodyDetails: "",

          criminalCaseDeclared:
            !!formData.preOnboardingOtherDetails.legalHistory,

          criminalCaseDetails: formData.preOnboardingOtherDetails.legalHistory,

          additionalInformation:
            formData.preOnboardingOtherDetails.otherInformation,
        },

        preOnboardingDocuments: [],
      };

      await jobsApiService.saveOtherDetails(applicationId, payload);

      return true;
    } catch (error) {
      console.error(error);

      toast.error("Failed to save Other Details.");

      return false;
    }
  };
  const savePreviousDeatilsPreOnboardingProfile = async () => {
    try {
      const payload = mapPreviousOrganisationPayload(
        formData,
        attestationDetails,
      );
      await jobsApiService.saveOrUpdatePreOnboardingResidentProfile(
        applicationId,
        payload,
      );

      return true;
    } catch (error) {
      console.error("Error Saving Pre-Onboarding Profile", error);

      toast.error("Failed to save onboarding details.");

      return false;
    }
  };

  const handleAddressProofUpload = async (file) => {
    try {
      const response = await jobsApiService.uploadProfileFile(
        applicationId,
        "ADDRESS_PROOF",
        file,
      );

      setFormData((prev) => ({
        ...prev,
        addressProofFile: file,
        addressProofFileUrl:
          response?.data?.documentUrl || response?.data?.fileUrl || "",
      }));
    } catch (error) {
      console.error("Address proof upload failed", error);
    }
  };
  const handleProfileDocumentUpload = async (
    file,
    documentType,
    fileKey,
    urlKey,
    nameKey,
    documentIdKey,
  ) => {
    try {
      const response = await jobsApiService.uploadProfileFile(
        applicationId,
        documentType,
        file,
      );
      setFormData((prev) => ({
        ...prev,
        [fileKey]: file,
        [urlKey]: response?.data?.documentUrl || response?.data?.fileUrl || "",
        [nameKey]: response?.data?.documentName || file.name,
        [documentIdKey]: response?.data?.id || null,
        ...(documentType === "PAN_CARD" && {
          panCanDelete: true,
        }),

        ...(documentType === "DRIVING_LICENSE" && {
          drivingLicenceCanDelete: true,
        }),

        ...(documentType === "PASSPORT" && {
          passportCanDelete: true,
        }),

        ...(documentType === "VOTER_ID" && {
          voterIdCanDelete: true,
        }),
      }));
    } catch (error) {
      console.error(error);
      toast.error("File upload failed");
    }
  };
  const handleDeleteProfileDocument = async (
    documentId,
    fileKey,
    urlKey,
    nameKey,
    documentIdKey,
  ) => {
    try {
      await jobsApiService.deleteResidentFile(documentId);

      setFormData((prev) => ({
        ...prev,
        [fileKey]: null,
        [urlKey]: "",
        [nameKey]: "",
        [documentIdKey]: null,
      }));

      toast.success("Document deleted successfully.");
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete document.");
    }
  };

  const handleAttestationDocument = async (file, index) => {
    try {
      const response = await jobsApiService.uploadResidentFile(
        applicationId,
        "RESIDENTIAL_PROOF",
        file,
      );

      setAttestationDetails((prev) => {
        const updated = [...prev];

        updated[index] = {
          ...updated[index],
          attestationDocument: file,
          preOnboardingDocumentId: response?.data?.id,
          documentUrl: response?.data?.documentUrl,
          documentName: response?.data?.documentName,
        };

        return updated;
      });
    } catch (error) {
      console.error(error);
    }
  };
  const handleExperienceCertificate = async (file, index) => {
    try {
      const response = await jobsApiService.uploadResidentFile(
        applicationId,
        "EXPERIENCE_CERTIFICATE",
        file,
      );
      setFormData((prev) => {
        const updated = [...prev.experienceDetails];

        updated[index] = {
          ...updated[index],
          experienceCertificate: file,
          experienceCertificateUrl: response?.data?.documentUrl,
          experienceCertificateName: response?.data?.documentName,
          preOnboardingDocumentId: response?.data?.id,
        };
        return {
          ...prev,
          experienceDetails: updated,
        };
      });
      setErrors((prev) => ({
        ...prev,
        experienceDetails: {
          ...prev.experienceDetails,
          [index]: {
            ...prev.experienceDetails?.[index],
            experienceCertificate: "",
          },
        },
      }));
    } catch (error) {
      console.error(error);
    }
  };
  const handlePersonalDetailsNext = async () => {
    const personalErrors = validatePersonalDetails(formData);
    const addressErrors = validateAddress(formData);

    const validationErrors = {
      ...personalErrors,
      ...addressErrors,
    };

    setErrors(validationErrors);

    const errorCount = Object.keys(validationErrors).length;

    if (errorCount > 0) {
      scrollToFirstError();
      toast.error(`Please fill all required fields.`, {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    const saved = await savePreOnboardingProfile();

    toast.success("Step 1 completed and saved successfully.", {
      position: "top-right",
      autoClose: 3000,
    });
    if (!saved) return;

    setActiveStep(1);
  };

  const handlePreviousOrganisationNext = async () => {
    const experienceErrors = validatePreviousOrganisationDetails(formData);

    const attestationErrors = validateAttestationDetails(attestationDetails);

    const hasExperienceErrors =
      Object.keys(experienceErrors?.experienceDetails || {}).length > 0;

    const hasAttestationErrors = Object.keys(attestationErrors).length > 0;

    setErrors({
      ...experienceErrors,
      attestation: attestationErrors,
    });

    if (hasExperienceErrors || hasAttestationErrors) {
      scrollToFirstError();

      toast.error("Please fill all required fields.", {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    const saved = await savePreviousDeatilsPreOnboardingProfile();

    if (!saved) return;

    toast.success("Step 2 completed and saved successfully.", {
      position: "top-right",
      autoClose: 3000,
    });

    setActiveStep(2);
  };

  return (
    <>
      <Header hideProfileTabs={true} />
      <div className="onboarding-container">
        <div className="step-sidebar">
          <div className="sidebar-header">
            <div className="d-flex align-items-center mb-2">
              <button
                type="button"
                className="btn btn-link p-0 me-2"
                style={{
                  color: "black",
                  textDecoration: "none",
                }}
                onClick={() => setShowBackModal(true)}
              >
                <FontAwesomeIcon icon={faAngleLeft} size="lg" />
              </button>

              <h5 className="mb-0">Onboarding Details</h5>
            </div>
            {/* <h5>Onboarding Details</h5> */}
            <p>Complete all the steps below</p>
            {/* <p>{activeStep + 1} of {steps.length} Steps</p> */}
            <div className="progress mt-3">
              <div
                className="progress-bar"
                style={{
                  width: `${((activeStep + 1) / steps.length) * 100}%`,
                  background: "#f26623",
                }}
              />
            </div>

            <p className="mt-2">
              {activeStep + 1} of {steps.length} Steps
            </p>
          </div>

          {steps.map((step, index) => (
            <div
              key={index}
              className={`timeline-step ${index === activeStep
                  ? "active"
                  : index < activeStep
                    ? "completed"
                    : ""
                }`}
            // onClick={() => setActiveStep(index)}
            >
              <div className="timeline-left">
                <div className="timeline-circle">
                  {index < activeStep ? (
                    <FontAwesomeIcon icon={faCheck} />
                  ) : (
                    index + 1
                  )}
                </div>

                {index !== steps.length - 1 && (
                  <div className="timeline-line"></div>
                )}
              </div>

              <div className="timeline-content">
                <h6>{step}</h6>
              </div>
            </div>
          ))}
        </div>
        {/* Right Content */}
        <div
          ref={contentRef}
          className="step-content"
          style={{
            paddingTop: "35px",
            paddingBottom: "50px",
          }}
        >
          {/* Step 1 */}
          {activeStep === 0 && (
            <>
              <Details
                formData={formData}
                setFormData={setFormData}
                handleChange={handleChange}
                handleAddressChange={handleAddressChange}
                errors={errors}
                setErrors={setErrors}
                handleAddressProofUpload={handleAddressProofUpload}
                handleProfileDocumentUpload={handleProfileDocumentUpload}
                handleDeleteProfileDocument={handleDeleteProfileDocument}
                states={masterData?.states || []}
                districts={masterData?.districts || []}
                cities={masterData?.cities || []}
              />

              <div className="text-end mt-3" style={{ paddingRight: "90px" }}>
                <button
                  className="btn text-white"
                  style={{
                    backgroundColor: "#f26623",
                    borderColor: "#f26623",
                  }}
                  onClick={handlePersonalDetailsNext}
                >
                  Next
                </button>
              </div>
            </>
          )}

          {/* Step 2 */}
          {activeStep === 1 && (
            <>
              <PreviousOrganisationDetails
                formData={formData}
                setFormData={setFormData}
                handleChange={handleChange}
                handleExperienceChange={handleExperienceChange}
                handleAttestationChange={handleAttestationChange}
                errors={errors}
                experienceDetails={formData.experienceDetails}
                attestationDetails={attestationDetails}
                setAttestationDetails={setAttestationDetails}
                handleAttestationDocument={handleAttestationDocument}
                states={masterData?.states || []}
                districts={masterData?.districts || []}
                cities={masterData?.cities || []}
                setErrors={setErrors}
                handleAddExperience={handleAddExperience}
                handleRemoveExperience={handleRemoveExperience}
                handleExperienceCertificate={handleExperienceCertificate}
                isSubmitted={isSubmitted}
              />

              <div
                className="d-flex justify-content-between mt-3"
                style={{ paddingRight: "90px" }}
              >
                <button
                  className="btn btn-secondary"
                  onClick={() => setActiveStep(0)}
                >
                  Previous
                </button>

                <button
                  className="btn text-white"
                  style={{
                    backgroundColor: "#f26623",
                    borderColor: "#f26623",
                  }}
                  onClick={handlePreviousOrganisationNext}
                >
                  Next
                </button>
              </div>
            </>
          )}

          {/* Step 3 */}
          {activeStep === 2 && (
            <>
              <QualificationFamilyDetails
                applicationId={applicationId}
                formData={formData}
                setFormData={setFormData}
                handleChange={handleChange}
                handleQualificationChange={handleQualificationChange}
                handleCertificationChange={handleCertificationChange}
                handleFamilyChange={handleFamilyChange}
                handleGratuityChange={handleGratuityChange}
                addCertificate={addCertificate}
                removeCertificate={removeCertificate}
                errors={errors}
                addFamily={addFamily}
                removeFamily={removeFamily}
                addNominee={addNominee}
                removeNominee={removeNominee}
              />

              <div
                className="d-flex justify-content-between mt-3"
                style={{ paddingRight: "90px" }}
              >
                <button
                  className="btn btn-secondary"
                  onClick={() => setActiveStep(1)}
                >
                  Previous
                </button>

                <button
                  className="btn text-white"
                  style={{
                    backgroundColor: "#f26623",
                    borderColor: "#f26623",
                  }}
                  onClick={handleQualificationNext}
                >
                  Next
                </button>
              </div>
            </>
          )}

          {/* Step 4 */}
          {activeStep === 3 && (
            <>
              <OtherDetails
                applicationId={applicationId}
                formData={formData}
                setFormData={setFormData}
                handleChange={handleOtherDetailsChange}
                handleReferenceChange={handleReferenceChange}
                errors={errors}
              />

              <div
                className="d-flex justify-content-between mt-3"
                style={{ paddingRight: "90px" }}
              >
                <button
                  className="btn btn-secondary"
                  onClick={() => setActiveStep(2)}
                >
                  Previous
                </button>

                <button
                  className="btn text-white"
                  style={{
                    backgroundColor: "#f26623",
                    borderColor: "#f26623",
                  }}
                  onClick={handleOtherDetailsSubmit}
                >
                  Submit
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />

      <Modal show={showSuccessModal} backdrop="static" centered>
        <Modal.Body className="text-center p-4">
          <div
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              background: "#e8f5e9",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
            }}
          >
            <FontAwesomeIcon
              icon={faCheck}
              style={{
                color: "#28a745",
                fontSize: "32px",
              }}
            />
          </div>

          <h4
            style={{
              color: "#28a745",
              fontWeight: "600",
            }}
          >
            Success
          </h4>

          <p
            className="mt-3 mb-4"
            style={{
              color: "#6c757d",
              fontSize: "15px",
            }}
          >
            Employee Onboarding completed successfully.
          </p>

          <button
            className="btn orange-button px-4"
            onClick={() => {
              setShowSuccessModal(false);
              navigate("/candidate-portal", {
                state: {
                  activeTab: "applied-jobs",
                },
              });
            }}
          >
            OK
          </button>
        </Modal.Body>
      </Modal>
      {/* <Modal
                show={showSuccessModal}
                backdrop="static"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Success
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    Employee Onboarding completed successfully.
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        onClick={() => {
                            setShowSuccessModal(false);
                            navigate("/candidate-portal", { state: { activeTab: "applied-jobs" } });
                        }}
                    >
                        OK
                    </Button>
                </Modal.Footer>
            </Modal> */}

      <Modal
        show={showBackModal}
        onHide={() => setShowBackModal(false)}
        centered
      >
        <Modal.Body className="text-center p-4">
          <div
            style={{
              fontSize: "50px",
              color: "#f26623",
            }}
          >
            <FontAwesomeIcon icon={faTriangleExclamation} />
          </div>

          <h5 className="mt-3">Leave this page?</h5>

          <p className="text-muted">Any unsaved changes will be lost.</p>

          <div className="d-flex justify-content-center gap-3 mt-4">
            <button
              className="btn btn-secondary imp-digi"
              onClick={() => setShowBackModal(false)}
            >
              Stay Here
            </button>

            <button
              className="btn orange-button "
              onClick={() => {
                setShowBackModal(false);
                navigate("/candidate-portal", {
                  state: {
                    activeTab: "applied-jobs",
                  },
                });
              }}
            >
              Leave Page
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default EmployeeOnboardingForm;
